export const connectionTypeFromDto = (dto) => {
  if (!dto) return {};

  return {
    id: dto.id,
    code: dto.code,
    name: dto.name,
  };
};
